<template>
  <div>
    <table class="table-condensed table-striped table-bordered">
      <tbody>
        <tr>
          <th style="width: 150px">Chave</th>
          <th style="width: 150px">Valor</th>
        </tr>
        <tr v-for="(value, key) in dataObject" :key="key">
          <td>{{ key }}</td>
          <td>
            <template v-if="key.toLowerCase() === 'sql'">
              <button class="btn btn-sm btn-info" @click="abrirModalSQL(value, key)">
                Ver SQL
              </button>
            </template>
            <template v-else-if="key.toLowerCase() === 'sql_diff'">
              <button class="btn btn-sm btn-info" @click="abrirModalDiffSQL(value)">
                Ver Diff SQL
              </button>
            </template>
            <template v-else-if="isImageKey(key) && value">
              <div class="kv-img-wrapper">
                <img :src="value" :alt="key" class="kv-img-thumb" @error="onImgError" />
                <a :href="value" target="_blank" rel="noopener" class="kv-img-link">ver</a>
              </div>
            </template>
            <template v-else-if="isColorKey(key) && value">
              <span class="kv-color-swatch" :style="{ backgroundColor: value }"></span>
              <span class="kv-color-hex">{{ value }}</span>
            </template>
            <template v-else-if="isBooleanValue(value)">
              <span class="badge" :class="value ? 'badge-success' : 'badge-secondary'">
                {{ value ? 'Sim' : 'Não' }}
              </span>
            </template>
            <template v-else-if="Array.isArray(value)">
              <span v-if="value.length === 0" class="text-muted">— vazio —</span>
              <div v-else class="kv-array">
                <span
                  v-for="(item, idx) in value"
                  :key="idx"
                  class="badge badge-light kv-array-item"
                >
                  {{ formatArrayItem(item) }}
                </span>
              </div>
            </template>
            <template v-else-if="isObjectValue(value)">
              <pre class="kv-json">{{ prettyJson(value) }}</pre>
            </template>
            <template v-else-if="value === null || value === ''">
              <span class="text-muted">—</span>
            </template>
            <template v-else>
              {{ value }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>


    <div v-if="exibirModalSQL" class="modal fade show d-block" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">SQL da Consulta</h5>
            <button type="button" class="close" @click="fecharModalSQL">&times;</button>
          </div>
          <div class="modal-body">
            <CodeEditor
              v-model="sqlAtual.sql"
              :readonly="true"
              :scriptMode="'SQL'"
            />
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-primary" @click="copiarSql">Copiar SQL</button>
            <button class="btn btn-sm btn-secondary" @click="fecharModalSQL">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="exibirModalDiffSQL" class="modal fade show d-block" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-xl" style="max-width: 95vw; width: 95vw;">
        <div class="modal-content" style="height: 90vh;">
          <div class="modal-header">
            <h5 class="modal-title">Diff SQL da Consulta</h5>
            <button type="button" class="close" @click="fecharModalDiffSQL">&times;</button>
          </div>
          <div class="modal-body" style="overflow-y: auto; max-height: calc(90vh - 120px);">
            <CodeDiff
              :old-string="currentDiff.old"
              :new-string="currentDiff.new"
              :output-format="'side-by-side'"
              :forceInlineComparison="true"
              :language="'sql'"
            />
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-secondary" @click="fecharModalDiffSQL">Fechar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CodeEditor from "@/components/form/CodeEditor.vue";
import { CodeDiff } from 'v-code-diff'

export default {
  name: "KeyValueTable",
  components: { CodeEditor, CodeDiff },
  props: ['dataObject'],
  data() {
    return {
      exibirModalSQL: false,
      exibirModalDiffSQL: false,
      sqlAtual: {
        sql: null,
        index: null
      },
      diffs: [],
      currentDiff: {
        old: null,
        new: null
      }
    };
  },
  methods: {
    abrirModalSQL(sql, index) {
      this.sqlAtual = { sql, index };
      this.exibirModalSQL = true;
    },
    fecharModalSQL() {
      this.exibirModalSQL = false;
      this.sqlAtual = {
        sql: null,
        index: null
      };
    },
    abrirModalDiffSQL(diff) {
      this.currentDiff = {
        old: diff.dados_anteriores || '',
        new: diff.dados_novos || ''
      };
      this.exibirModalDiffSQL = true;
    },
    fecharModalDiffSQL() {
      this.exibirModalDiffSQL = false;
      this.currentDiff = {
        old: null,
        new: null
      };
    },
    copiarSql() {
      navigator.clipboard.writeText(this.sqlAtual.sql);
    },
    isImageKey(key) {
      const k = String(key).toLowerCase();
      return k.includes('imagem') || k.includes('imagen') || k.endsWith('_url') || k === 'foto' || k === 'avatar';
    },
    isColorKey(key) {
      const k = String(key).toLowerCase();
      return k === 'cor' || k === 'color';
    },
    isBooleanValue(value) {
      return typeof value === 'boolean';
    },
    isObjectValue(value) {
      return value !== null && typeof value === 'object' && !Array.isArray(value);
    },
    prettyJson(value) {
      try {
        return JSON.stringify(value, null, 2);
      } catch (e) {
        return String(value);
      }
    },
    formatArrayItem(item) {
      if (item === null || item === undefined) return '—';
      if (typeof item === 'object') {
        if (item.descricao) return `${item.id ?? ''} - ${item.descricao}`.trim();
        if (item.id !== undefined) return String(item.id);
        try {
          return JSON.stringify(item);
        } catch (e) {
          return String(item);
        }
      }
      return String(item);
    },
    onImgError(e) {
      e.target.style.display = 'none';
    },
  },
}
</script>

<style scoped>
  table td, table th {
    padding: 2px;
    word-wrap: anywhere;
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }

  .kv-img-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .kv-img-thumb {
    width: 64px;
    height: 48px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    background: #f8f9fa;
  }

  .kv-img-link {
    font-size: 10px;
    text-decoration: underline;
  }

  .kv-color-swatch {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    border: 1px solid #ced4da;
    vertical-align: middle;
    margin-right: 6px;
  }

  .kv-color-hex {
    font-family: monospace;
    font-size: 11px;
    vertical-align: middle;
  }

  .kv-array {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
  }

  .kv-array-item {
    font-family: monospace;
    font-size: 10px;
  }

  .kv-json {
    font-size: 10px;
    max-height: 180px;
    overflow: auto;
    margin: 0;
    padding: 4px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 3px;
  }
</style>
